import { isStagingRuntime } from '../../runtime/env';

export function getVistaHostKey(): string {
    return isStagingRuntime() ||
        (typeof window !== 'undefined' && window.location.hostname.includes('staging'))
        ? 'staging.vistaprint.com'
        : 'vistaprint.com';
}
